export default "__VITE_ASSET__CTkm_Lm6__"